import * as React from 'react';
import { CardHeader, CardTitle } from '@/components/ui/card';

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  /** Right-aligned plain text (e.g. "Managed by admin"). Ignored if `action` is set. */
  hint?: string;
  /** Right-aligned interactive content (e.g. month-nav buttons, selects). */
  action?: React.ReactNode;
}

/**
 * Canonical card section header used across the app: a teal icon-in-box on the
 * left, title text, and an optional right-aligned hint or action slot.
 */
export function SectionHeader({ icon, title, hint, action }: SectionHeaderProps) {
  return (
    <CardHeader className="border-b border-border/40 px-4 py-2">
      <CardTitle className="flex flex-col gap-2 text-sm font-semibold text-primary sm:flex-row sm:items-center sm:justify-between">
        <span className="flex min-w-0 shrink-0 items-center gap-2">
          <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary [&>svg]:h-3.5 [&>svg]:w-3.5">
            {icon}
          </span>
          {title}
        </span>
        {action ? (
          <span className="flex flex-wrap items-center gap-1.5">{action}</span>
        ) : hint ? (
          <span className="text-xs font-normal text-muted-foreground">{hint}</span>
        ) : null}
      </CardTitle>
    </CardHeader>
  );
}
